<script lang="ts" setup>
import MortgageProductLpTemplate from '~/components/templates/ProductLpTemplate/mortgage/MortgageProductLpTemplate.vue';
</script>

<template>
  <MortgageProductLpTemplate />
</template>

<style lang="scss" module></style>
